import { render } from "./resetpasswordpage.vue?vue&type=template&id=b3077962&scoped=true"
import script from "./resetpasswordpage.vue?vue&type=script&lang=js"
export * from "./resetpasswordpage.vue?vue&type=script&lang=js"

import "./resetpasswordpage.vue?vue&type=style&index=0&id=b3077962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3077962"]])

export default __exports__